import { render, staticRenderFns } from "./SingleAd.vue?vue&type=template&id=1b26ab8c&"
import script from "./SingleAd.vue?vue&type=script&lang=js&"
export * from "./SingleAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports